// extracted by mini-css-extract-plugin
export default {"container":"ParkingDetail_container__oPWOR","header":"ParkingDetail_header__eMoCo","backButton":"ParkingDetail_backButton__6I1sg","dashboard":"ParkingDetail_dashboard__fmixY"};